import { jsx } from "react/jsx-runtime";
import ShoppingBagIcon from "@mui/icons-material/ShoppingBag";
import { validateTidalLicense } from "../../base/index.js";
function ShoppingBag(props) {
  return /* @__PURE__ */ jsx(
    ShoppingBagIcon,
    {
      "data-testid": "ShoppingBag",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "ShoppingBag",
      "data-tidal-icon-meta": "money,invoices,payments"
    }
  );
}
ShoppingBag.tidalIconMeta = {
  categories: "money,invoices,payments",
  name: "ShoppingBag"
};
validateTidalLicense();
export {
  ShoppingBag
};
//# sourceMappingURL=ShoppingBag.js.map
